import { localizeHtml } from "../../lib/content-blocks";

/**
 * Renders captured HTML. Safe because prepare-content.py strips every tag and
 * attribute outside a small allowlist before it reaches content.json.
 */
export default function RichText({ html, className }) {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: localizeHtml(html) }}
    />
  );
}
